import React, {useState, useEffect} from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  SlTabGroup,
  SlTab,
  SlTabPanel,
} from "@shoelace-style/shoelace/dist/react";
import ClientTrackerMonth from "./ClientTrackerMonth";
import ClinetWiseRevenueMonth from "./ClinetWiseRevenueMonth";
import RevenueSummary from "./RevenueSummary";
import PlanningSheetRollingMonth from "./PlanningSheetRollingMonth";
import AccountConversionRollingAverage from "./AccountConversionRollingAverage";
import AccountManagementTracking from "./AccountManagementTracking";

function MonthlyReports() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(tab || "revenue");

  useEffect(() => {
    if (tab && tab !== currentTab) setCurrentTab(tab);
  }, [tab]);

  const handleTabChange = (e) => {
    const name = e.detail.name;
    setCurrentTab(name);
    navigate(`/home/monthlyreview/${name}`, { replace: true });
  };

  return (
    <>
      <h5>Monthly Reports</h5>
      <SlTabGroup onSlTabShow={handleTabChange}>
        <SlTab slot="nav" panel="revenue" active={currentTab === 'revenue'}>Revenue Summary</SlTab>
        <SlTab slot="nav" panel="client-tracker" active={currentTab === 'client-tracker'}>Client Tracker Month</SlTab>
        <SlTab slot="nav" panel="clientwise-revenue" active={currentTab === 'clientwise-revenue'}>Clinet Wise Revenue</SlTab>
        <SlTab slot="nav" panel="Account-conversion" active={currentTab === 'Account-conversion'}>Account Conversion Rolling Average</SlTab>
        <SlTab slot="nav" panel="Account-management" active={currentTab === 'Account-management'}>Account Management Tracking</SlTab>
        <SlTab slot="nav" panel="planning" active={currentTab === 'planning'}>Planning Sheet Rolling Month</SlTab>
        <SlTabPanel name="client-tracker">
            {currentTab === 'client-tracker' && <ClientTrackerMonth />}
        </SlTabPanel>
        <SlTabPanel name="clientwise-revenue">
          {currentTab === 'clientwise-revenue' && <ClinetWiseRevenueMonth />}
          </SlTabPanel>
        <SlTabPanel name="revenue">
          {currentTab === 'revenue' && <RevenueSummary />}
          </SlTabPanel>
          <SlTabPanel name="planning">
            {currentTab === 'planning' && <PlanningSheetRollingMonth />}
          </SlTabPanel>
        <SlTabPanel name="Account-conversion">
          {currentTab === 'Account-conversion' && <AccountConversionRollingAverage/>}
        </SlTabPanel>
        <SlTabPanel name="Account-management">
            {currentTab === 'Account-management' && <AccountManagementTracking />}
        </SlTabPanel>
      </SlTabGroup>
    </>
  );
}

export default MonthlyReports;
